import Vue from 'vue'
import Router from 'vue-router'
import _ from 'lodash'
import homeRoutes from '@/components/home/home-router'
import serviceRoutes from '@/components/service/service-router'
import lawyerRoutes from '@/components/lawyer/lawyer-router'
import advantageRoutes from '@/components/advantage/advantage-router'
import articleRoutes from '@/components/article/article-router'
import joinUsRoutes from '@/components/join-us/join-us-router'
import fieldDetailRoutes from '@/components/field-detail/field-detail-router'
import LawyerDetailRoutes from '@/components/lawyer-detail/lawyer-detail-router'
import ArticleDetailRoutes from '@/components/article-detail/article-detail-router'
import JoinUsDetailRoutes from '@/components/join-us-detail/join-us-detail-router'
import LoginRoutes from '@/components/login/login-router'
import RegisterRoutes from '@/components/register/register-router'
import ConsultationRoutes from '@/components/consultation/consultation-router'
Vue.use(Router)
export default new Router({
  routes: _.union(
    homeRoutes, serviceRoutes, lawyerRoutes,
    advantageRoutes, articleRoutes, joinUsRoutes,
    fieldDetailRoutes, LawyerDetailRoutes, ArticleDetailRoutes,
    JoinUsDetailRoutes, LoginRoutes, RegisterRoutes, ConsultationRoutes
  )
})



// WEBPACK FOOTER //
// ./src/router/index.js